/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/CustomField/Enum/Location.php */
export const location = {
	invoice: 'invoice',
} as const

/** @see backend/nexus/modules/CustomField/Enum/Location.php */
export type Location = (typeof location)[keyof typeof location]
